import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlice";
import presentationReducer from "./features/presentations/presentationsSlice";
import adminReducer from "./features/admin/adminSlice";
import { authMiddleware } from "./middleware/authMiddleware";
import reportReducer from "./features/report/reportSlice";
import rolesReducer from "./features/roles/rolesSlice";
import brandsReducer from "./features/brands/brandsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    admin: adminReducer,
    presentation: presentationReducer,
    report: reportReducer,
    roles: rolesReducer,
    brands: brandsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authMiddleware),
});
